import { getUniqueId } from "../../../../../../helpers";
import {
  IRiskProfileCargoCglCoverageRow,
  INITIAL_RISK_PROFILE,
} from "../../../../../../redux/commAutoPolicy/commAutoRiskProfile/commAutoRiskProfile.types";

// Route path constants
export const RISK_PROFILE_ROOT = "risk-profile-tab";
export const RISK_PROFILE_LIST =
  "/comm-automobile-policy/:customerId/risk-profile-tab/:customerPolicyId";
export const RISK_PROFILE_CREATE =
  "/comm-automobile-policy/:customerId/risk-profile-tab/:customerPolicyId/risk-profile";
export const RISK_PROFILE_EDIT =
  "/comm-automobile-policy/:customerId/risk-profile-tab/:customerPolicyId/risk-profile/:incrementalNumber";

// Default Cargo & CGL coverage rows seeded on creation (Requirement 8.2)
export const CARGO_CGL_DEFAULT_ROWS: IRiskProfileCargoCglCoverageRow[] = [
  { key: getUniqueId(), coverage: "Motor Truck Cargo (per vehicle)", limit: null, deductible: null },
  { key: getUniqueId(), coverage: "Cargo Catastrophic Limit", limit: null, deductible: null },
  { key: getUniqueId(), coverage: "Terminal Legal Liability", limit: null, deductible: null },
  { key: getUniqueId(), coverage: "Commercial General Liability - Bodily Injury & Property Damage", limit: null, deductible: null },
  { key: getUniqueId(), coverage: "Standard Non-Owned Automobile Policy - SPF No. 6", limit: null, deductible: null },
  { key: getUniqueId(), coverage: "Legal Liability For Damage To Hired Automobiles Endorsement - SEF No. 94", limit: null, deductible: null },
  { key: getUniqueId(), coverage: "Tenants Legal Liability", limit: null, deductible: null },
  { key: getUniqueId(), coverage: "Warehouseman's Legal Liability", limit: null, deductible: null },
];

// Default empty risk profile record for creation mode
export const INITIAL_RISK_PROFILE_STATE = INITIAL_RISK_PROFILE;
